<template>
  <section class="tw-flex tw-items-start">
    <div class="settings-form-row-left">
      <WdsText primary>
        {{ title }}
      </WdsText>
      <div class="tw-mt-2">
        <slot name="subtitle">
          <WdsText secondary>
            {{ subtitle }}
          </WdsText>
        </slot>
      </div>
    </div>
    <div class="settings-form-row-right tw-mx-13">
      <slot></slot>
    </div>
  </section>
</template>

<script>
import { WdsText } from '@worksome/wds-components'

export default {
  components: {
    WdsText,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped>
.settings-form-row-left {
  width: 300px;
}

.settings-form-row-right {
  width: 462px;
}
</style>
